module.exports = __webpack_public_path__ + "5f5a3e28d049804c286a6999eb695662.jpg";